document.addEventListener('DOMContentLoaded', function () {

  // ---- HAMBURGER ----
  const hamburger = document.getElementById('hamburger');
  const mobileMenu = document.getElementById('mobileMenu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      mobileMenu.classList.toggle('open');
    });
  }

  // ---- MOBILE DROPDOWNS ----
  document.querySelectorAll('.mobile-dropdown-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      this.nextElementSibling.classList.toggle('open');
    });
  });

  // ---- HERO SLIDER ----
  const slides = document.querySelectorAll('.hero-slide');
  const dots = document.querySelectorAll('.slider-dot');
  const prevBtn = document.getElementById('sliderPrev');
  const nextBtn = document.getElementById('sliderNext');

  if (slides.length > 1) {
    let current = 0;
    let timer;

    function goTo(n) {
      slides[current].classList.remove('active');
      dots[current] && dots[current].classList.remove('active');
      current = (n + slides.length) % slides.length;
      slides[current].classList.add('active');
      dots[current] && dots[current].classList.add('active');
    }

    function startAuto() {
      timer = setInterval(() => goTo(current + 1), 5000);
    }

    function resetAuto() {
      clearInterval(timer);
      startAuto();
    }

    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        goTo(parseInt(dot.dataset.index));
        resetAuto();
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', () => { goTo(current - 1); resetAuto(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { goTo(current + 1); resetAuto(); });

    startAuto();
  }

  // ---- VIDEO PLAY ----
  document.querySelectorAll('.video-wrapper').forEach(wrapper => {
    const video = wrapper.querySelector('video');
    const overlay = wrapper.querySelector('.video-overlay');
    const playBtn = wrapper.querySelector('.video-play-btn');
    if (video && playBtn) {
      playBtn.addEventListener('click', () => {
        if (video.paused) {
          video.play();
          overlay.style.opacity = '0';
          overlay.style.pointerEvents = 'none';
        } else {
          video.pause();
          overlay.style.opacity = '1';
          overlay.style.pointerEvents = 'all';
        }
      });
    }
  });

});

// =============================================
// SEARCH AUTOCOMPLETE
// =============================================
(function() {
  const input = document.getElementById('searchInput');
  const suggestions = document.getElementById('searchSuggestions');
  const wrap = document.getElementById('searchWrap');

  if (!input || !suggestions) return;

  let debounceTimer;
  let currentQuery = '';

  function formatMoney(cents) {
    return '$ ' + (cents / 100).toLocaleString('es-MX', {minimumFractionDigits: 2});
  }

  function highlight(text, query) {
    if (!query) return text;
    const regex = new RegExp('(' + query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
    return text.replace(regex, '<em>$1</em>');
  }

  function showLoading() {
    suggestions.innerHTML = '<div class="suggestion-loading">Buscando...</div>';
    suggestions.classList.add('active');
  }

  function hideSuggestions() {
    suggestions.classList.remove('active');
    suggestions.innerHTML = '';
  }

  async function fetchSuggestions(query) {
    if (query.length < 2) { hideSuggestions(); return; }
    currentQuery = query;
    showLoading();

    try {
      const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`);
      const data = await res.json();

      if (query !== currentQuery) return;

      const products = data.resources?.results?.products || [];

      if (products.length === 0) {
        suggestions.innerHTML = '<div class="suggestion-empty">No se encontraron productos</div>';
        suggestions.classList.add('active');
        return;
      }

      let html = '';
      products.forEach(product => {
        const img = product.image
          ? `<img src="${product.image}" alt="${product.title}" class="suggestion-img" loading="lazy">`
          : `<div class="suggestion-img-placeholder">📦</div>`;

        const price = product.price ? formatMoney(product.price) : '';
        const title = highlight(product.title, query);

        html += `
          <a href="${product.url}" class="suggestion-item">
            ${img}
            <div class="suggestion-info">
              <div class="suggestion-title">${title}</div>
              <div class="suggestion-price">${price}</div>
              <div class="suggestion-stock">En stock</div>
            </div>
          </a>`;
      });

      html += `
        <div class="suggestion-footer">
          <a href="/search?type=product&q=${encodeURIComponent(query)}">Ver todos los resultados →</a>
        </div>`;

      suggestions.innerHTML = html;
      suggestions.classList.add('active');

    } catch(e) {
      hideSuggestions();
    }
  }

  input.addEventListener('input', function() {
    const query = this.value.trim();
    clearTimeout(debounceTimer);
    if (query.length < 2) { hideSuggestions(); return; }
    debounceTimer = setTimeout(() => fetchSuggestions(query), 280);
  });

  // Ocultar al hacer click fuera
  document.addEventListener('click', function(e) {
    if (!e.target.closest('#searchForm')) hideSuggestions();
  });

  // Mostrar de nuevo al enfocar si hay texto
  input.addEventListener('focus', function() {
    if (this.value.trim().length >= 2) fetchSuggestions(this.value.trim());
  });

})();

// =============================================
// CARRUSELES DE PRODUCTOS
// =============================================
(function() {
  function initCarousel(trackId, prevSelector, nextSelector) {
    const track = document.getElementById(trackId);
    if (!track) return;

    const cards = track.querySelectorAll('.product-card');
    if (!cards.length) return;

    let current = 0;
    const visibleCount = window.innerWidth > 1024 ? 5 :
                         window.innerWidth > 768 ? 4 :
                         window.innerWidth > 480 ? 2 : 1;
    const maxIndex = Math.max(0, cards.length - visibleCount);

    function getCardWidth() {
      return cards[0].getBoundingClientRect().width + 19.2; // gap 1.2rem = ~19.2px
    }

    function goTo(index) {
      current = Math.max(0, Math.min(index, maxIndex));
      track.style.transform = `translateX(-${current * getCardWidth()}px)`;
    }

    document.querySelectorAll(`.carousel-btn--prev[data-carousel="${prevSelector}"]`).forEach(btn => {
      btn.addEventListener('click', () => goTo(current - 1));
    });
    document.querySelectorAll(`.carousel-btn--next[data-carousel="${nextSelector}"]`).forEach(btn => {
      btn.addEventListener('click', () => goTo(current + 1));
    });
  }

  initCarousel('carouselFeaturedTrack', 'featured', 'featured');
  initCarousel('carouselBSTrack', 'bs', 'bs');
})();

// =============================================
// CARRUSEL AUTOMÁTICO SIN FLECHAS
// =============================================
(function() {
  function initAutoCarousel(trackId, intervalMs) {
    const track = document.getElementById(trackId);
    if (!track) return;

    const originalCards = Array.from(track.querySelectorAll('.product-card'));
    if (!originalCards.length) return;

    // Clonar tarjetas al final para loop infinito suave
    originalCards.forEach(card => {
      const clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });

    const allCards = track.querySelectorAll('.product-card');
    let current = 0;
    let isTransitioning = false;

    function getVisible() {
      const w = window.innerWidth;
      if (w > 1024) return 5;
      if (w > 768) return 4;
      if (w > 480) return 2;
      return 1;
    }

    function getCardWidth() {
      if (!allCards[0]) return 0;
      return allCards[0].getBoundingClientRect().width + 19.2;
    }

    function next() {
      if (isTransitioning) return;
      isTransitioning = true;
      current += 1;
      track.style.transition = 'transform 0.6s ease';
      track.style.transform = `translateX(-${current * getCardWidth()}px)`;

      // Cuando llega al final de los originales, salta sin animación al inicio
      track.addEventListener('transitionend', function onEnd() {
        track.removeEventListener('transitionend', onEnd);
        isTransitioning = false;
        if (current >= originalCards.length) {
          current = 0;
          track.style.transition = 'none';
          track.style.transform = 'translateX(0)';
        }
      });
    }

    setInterval(next, intervalMs || 3000);

    window.addEventListener('resize', () => {
      current = 0;
      track.style.transition = 'none';
      track.style.transform = 'translateX(0)';
    });
  }

  initAutoCarousel('carouselFeaturedTrack', 3000);
  initAutoCarousel('carouselBSTrack', 3500);
})();
